import { ServiceResource } from "types/service.type";
import { CrudService } from "./crudService";

const crud = new CrudService<ServiceResource, ServiceResource>("services");

export const serviceService = {
  ...crud,
};
